<template>
  <div class="fixed-asset-investment">
    <div class="title">
      <span>广东省民营固定资产投资</span>
    </div>
    <div class="chart-con">
      <v-chart ref="bar-chart" id="bar-chart" class="bar-chart" :options="chartOption" />
    </div>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartFixedAssetInvestment';
import { getFixedAssetInvestData } from '@/api/getChartData';
export default {
  name: 'FixedAssetInvestment',
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      chartOption: null,
      chartData: null,
    };
  },
  methods: {
    getData() {
      this.$api.screen
        .getPrivateInvestment({
          endYear: this.yearP,
        })
        .then((res) => {
          let { data } = res.data;
          let names = [],
            listData = {};
          if (data && data.yData?.length) {
            let fI = 0,
              lI = data.yData[0].data.length;
            names = data.yData
              .map((item) => {
                listData[item.name] = item.data;
                const firstIndex = item.data.findIndex((x) => x !== null && x !== '');
                const lastIndex = item.data.findLastIndex((x) => x !== null && x !== '') + 1;
                if (firstIndex !== -1 && firstIndex > fI) fI = firstIndex;
                if (lastIndex !== -1 && (lI === item.data.length || lastIndex > lI)) lI = lastIndex;
                return item.name;
              })
              .filter((item) => item.length > 2);
            names.push('同比');
            listData['年份'] = data.xData;
            for (const key in listData) {
              if (Object.hasOwnProperty.call(listData, key)) {
                const element = listData[key];
                listData[key] = element.slice(fI, lI);
              }
            }
          }
          let list = {
            yAxis: {
              names: ['单位：亿元', '单位：%'],
            },
            names: Array.from(names),
            // colorOpacity: true,
            data: [],
          };
          for (let i = 0; i < listData['年份'].length; i++) {
            let obj = {
              年份: listData['年份'][i],
              全省投资: '',
              民营投资: '',
              同比: '',
            };
            // if (listData['年份'][i] == 2021) {
            //   listData['年份'][i] = '2021(前两季度)';
            //   listData['全省投资'][i] = 19871;
            //   listData['民营投资'][i] = 10881.09;
            // }
            for (let key in listData) {
              obj[key] = listData[key][i] ? listData[key][i] : 'null';
            }
            list.data.push(obj);
          }
          this.chartData = list;
          this.chartOption = drawBar(list);
        });

      // getFixedAssetInvestData().then(res => {
      //   let year = new Set();
      //   let names = new Set();
      //   let data = [];
      //   res.RECORDS.map((item) => {
      //     year.add(item['年份']);
      //     names.add(item['类型']);
      //     data.push(item['总数'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         names: ['单位：亿元', '单位：%']
      //       },
      //       names: Array.from(names),
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let data = {};
      //     data.year = Array.from(year);
      //     data.province = this.filterData(res.RECORDS, '全省投资', '总数', '指标');
      //     data.private = this.filterData(res.RECORDS, '民营投资', '总数', '指标');
      //     data.rate = this.filterData(res.RECORDS, '同比', '总数', '指标');
      //     for (let i = 0; i < data.year.length; i++) {
      //       list.data.push({
      //         年份: data.year[i],
      //         全省投资: data.province[i],
      //         民营投资: data.private[i],
      //         同比: data.rate[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          data[key][keyName] ? arr.push(Number(data[key][keyName])) : arr.push();
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.fixed-asset-investment {
  .chart-box();
}
</style>
